import type { ApiResponse, Pagination } from "@/types";

import { BaseApi } from "../base.api";

export type WithdrawalStatus = "REQUESTED" | "PAID" | "REJECTED" | "CANCELLED";

export interface Withdrawal {
  id: number;
  teacherId: number;
  amountUzs: number;
  cardNumber: string;
  cardHolder: string;
  status: WithdrawalStatus;
  /** Shu paytgacha o'tkazilishi kerak (ariza + 3 ish kuni). */
  dueAt: string;
  processedAt: string | null;
  note: string | null;
  createdAt: string;
  teacher?: { id: number; firstName: string; lastName: string; email: string } | null;
  processedBy?: { id: number; firstName: string; lastName: string } | null;
  /**
   * Faqat ochiq arizada: o'qituvchining hozirgi balansi (shu ariza bilan).
   * Ariza summasidan kam bo'lsa — ariza paytidan beri pul qaytarilgan.
   */
  balanceUzs?: number;
}

export interface WithdrawalSummary {
  openCount: number;
  openAmountUzs: number;
  overdueCount: number;
  paidThisMonthUzs: number;
  paidTotalUzs: number;
}

export interface WithdrawalFilter {
  page?: number;
  limit?: number;
  status?: WithdrawalStatus;
  teacherId?: number;
}

/** O'qituvchilarning pul yechish arizalari — backend'dagi `WithdrawalsController`. */
export class WithdrawalsApi extends BaseApi {
  private readonly baseUrl = "/withdrawals";

  list(filter: WithdrawalFilter) {
    return this.request.get<Withdrawal[], Pagination<Withdrawal>>(this.baseUrl, {
      params: filter,
    });
  }

  summary() {
    return this.request.get<WithdrawalSummary, ApiResponse<WithdrawalSummary>>(
      `${this.baseUrl}/summary`,
    );
  }

  /** Pul o'qituvchi kartasiga o'tkazildi. */
  markPaid(id: number, note?: string) {
    return this.request.post<Withdrawal, ApiResponse<Withdrawal>>(`${this.baseUrl}/${id}/paid`, {
      note,
    });
  }

  /** Rad etish — summa o'qituvchi balansiga qaytadi. */
  reject(id: number, reason: string) {
    return this.request.post<Withdrawal, ApiResponse<Withdrawal>>(`${this.baseUrl}/${id}/reject`, {
      reason,
    });
  }
}

export const withdrawalsApi = new WithdrawalsApi();
